export const COMPLIANCE_DOCUMENT_ENTITY_ID = 'compliance:compliance_document'

export const complianceDocumentTypeValues = [
  'ROAD_CARRIER_AUTHORIZATION',
  'ROAD_LICENSE_DOMESTIC',
  'ROAD_LICENSE_EU_COMMUNITY',
  'ROAD_CPC',
  'ROAD_CEMT_PERMIT',
  'RAIL_UTK_LICENSE',
  'RAIL_SAFETY_CERT_A',
  'RAIL_SAFETY_CERT_B',
  'RAIL_ECM_CERTIFICATE',
  'RAIL_DRIVER_LICENSE',
  'RAIL_INFRA_AUTHORIZATION',
  'INSURANCE_OCP_ROAD',
  'INSURANCE_OC_BUSINESS',
  'INSURANCE_OCP_RAIL',
  'INSURANCE_OC_RAIL_INFRA',
  'INSURANCE_OCS_FORWARDER',
  'INSURANCE_OC_TERMINAL',
  'ADR_COMPANY_CERTIFICATE',
  'ADR_DRIVER_CERTIFICATE',
  'ADR_VEHICLE_APPROVAL',
  'RAIL_RID_CERTIFICATE',
  'BUSINESS_REGISTRATION',
  'VAT_CERTIFICATE',
  'SENT_REGISTRATION',
  'PORT_CONCESSION',
] as const

export type ComplianceDocumentType = (typeof complianceDocumentTypeValues)[number]

export const holderTypeValues = ['COMPANY', 'PERSON', 'VEHICLE'] as const
export type HolderType = (typeof holderTypeValues)[number]

export const insuredSumPerValues = ['PER_EVENT', 'PER_YEAR', 'AGGREGATE'] as const
export type InsuredSumPer = (typeof insuredSumPerValues)[number]

export const territorialScopeValues = ['PL_ONLY', 'EU', 'EUROPE', 'WORLDWIDE'] as const
export type TerritorialScope = (typeof territorialScopeValues)[number]

export const complianceDocumentStatusValues = [
  'VALID',
  'EXPIRING_SOON',
  'EXPIRED',
  'SUSPENDED',
  'NOT_PROVIDED',
  'REJECTED',
] as const
export type ComplianceDocumentStatus = (typeof complianceDocumentStatusValues)[number]

export const verificationStatusValues = ['UNVERIFIED', 'PENDING_REVIEW', 'VERIFIED', 'REJECTED'] as const
export type VerificationStatus = (typeof verificationStatusValues)[number]
